import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Layers, Boxes, ArrowRight } from "lucide-react";
import StatusPill from "../../components/primitives/StatusPill";
import "./DashboardPage.css";

function ActionCard({ icon: Icon, title, description, status, onClick, disabled }) {
    return (
        <button
            type="button"
            className={`action-card focus-ring ${disabled ? "action-card--disabled" : ""}`}
            onClick={disabled ? undefined : onClick}
            disabled={disabled}
            aria-label={title}
        >
            <div className="action-card__head">
                <div className="action-card__icon" aria-hidden="true">
                    <Icon size={18} />
                </div>
                {status && (
                    <StatusPill tone={disabled ? "idle" : "ready"}>{status}</StatusPill>
                )}
            </div>
            <div className="action-card__body">
                <h3 className="action-card__title">{title}</h3>
                <p className="action-card__desc">{description}</p>
            </div>
            <div className="action-card__foot">
                <span className="action-card__cta uppercase-label">
                    {disabled ? "Unavailable" : "Open"}
                </span>
                <ArrowRight
                    size={16}
                    className="action-card__arrow"
                    aria-hidden="true"
                />
            </div>
        </button>
    );
}

function DashboardPage({ user }) {
    const navigate = useNavigate();
    const greeting =
        user?.name?.split(" ")[0] || user?.displayName?.split(" ")[0] || "Operator";

    return (
        <div className="dashboard-page">
            <header className="dashboard-page__header">
                <div className="dashboard-page__eyebrow uppercase-label">
                    Console / Dashboard
                </div>
                <h1 className="dashboard-page__title">
                    Welcome, <span className="dashboard-page__title-name">{greeting}</span>
                </h1>
                <p className="dashboard-page__subtitle">
                    Select an operation to begin a packing run.
                </p>
            </header>

            <div className="dashboard-page__grid">
                <ActionCard
                    icon={Box}
                    title="Pack a single SKU"
                    description="Optimise how copies of one box type fit into a single shipping container. Fast for repeat-SKU freight."
                    status="Ready"
                    onClick={() => navigate("/visualizer")}
                />
                <ActionCard
                    icon={Layers}
                    title="Pack a manifest"
                    description="Pack multiple SKU types in one solve. Pick between volume-optimised and count-optimised solutions."
                    status="Ready"
                    onClick={() => navigate("/manifest")}
                />
                <ActionCard
                    icon={Boxes}
                    title="SKU catalog"
                    description="Save dimensions for each SKU and reuse them when filling out a manifest. Per-account, persistent."
                    status="Ready"
                    onClick={() => navigate("/catalog")}
                />
            </div>
        </div>
    );
}

export default DashboardPage;
